import { axiosInstance } from "./axiosInstace";
import { errorHandler } from "./errorHandler";
import { getAccessToken } from "utils/helper";

const makeRequest = (requestType, appendUrl, payload, fileType = false) => {
  axiosInstance.interceptors.request.use(
    (config) => {
      if (getAccessToken()) {
        config.headers.Authorization = `Bearer ${getAccessToken()}`;
      }

      if (fileType) {
        config.headers.contentType = "application/pdf";
        config.responseType = "arraybuffer";
      }

      return config;
    },
    (error) => {
      Promise.reject(error);
    }
  );

  const axiosGet = () => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(appendUrl)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(errorHandler(error));
        });
    });
  };

  const axiosPost = () => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .post(appendUrl, payload)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(errorHandler(error));
        });
    });
  };

  const axiosDelete = () => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .delete(appendUrl, payload)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(errorHandler(error));
        });
    });
  };

  const axiosPut = () => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .put(appendUrl, payload)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(errorHandler(error));
        });
    });
  };

  switch (requestType.toLowerCase()) {
    case "post":
      return axiosPost();

    case "get":
      return axiosGet();

    case "delete":
      return axiosDelete();

    case "put":
      return axiosPut();

    default:
      break;
  }
};

export default makeRequest;
